import React from 'react';

import S from './index.module.css';

import { PhoneImg } from './Phone';
import { MessagesImg } from './Messages';
import { CalendarImg } from './Calendar';
import { ClockImg } from './Clock';
import { NotesImg } from './Notes';
import { RemindersImg } from './Reminders';
import { MailImg } from './Mail';
import { AppStoreImg } from './AppStore';
import { VideosImg } from './Videos';
import { YouTubeImg } from './YouTube';
import { CalculatorImg } from './Calculator';
import { ITunesImg } from './ITunes';
import { StocksImg } from './Stocks';
import { VoiceMemosImg } from './VoiceMemos';
import { WeatherImg } from './Weather';
import { CameraImg } from './Camera';
import { MusicImg } from './Music';
import { ContactsImg } from './Contacts';

const Icon = ({ title, children, isOn, isLocked, idx }) => (
  <div
    className={S.icon}
    data-is-on={isOn}
    data-is-locked={isLocked}
    data-idx={idx}
  >
    {children}
    <span className={S.title}>{title}</span>
  </div>
);

const withIcon =
  ({ title }) =>
  (Component) => {
    return function TheIcon({ isOn, isLocked, idx }) {
      return (
        <Icon title={title} isOn={isOn} isLocked={isLocked} idx={idx}>
          <Component />
        </Icon>
      );
    };
  };

export const Phone = withIcon({ title: 'Phone' })(PhoneImg);
export const Camera = withIcon({ title: 'Camera' })(CameraImg);
export const Music = withIcon({ title: 'Music' })(MusicImg);
export const Contacts = withIcon({ title: 'Contacts' })(ContactsImg);
export const Messages = withIcon({ title: 'Messages' })(MessagesImg);
export const Calendar = withIcon({ title: 'Calendar' })(CalendarImg);
export const Clock = withIcon({ title: 'Clock' })(ClockImg);
export const Notes = withIcon({ title: 'Notes' })(NotesImg);
export const Reminders = withIcon({ title: 'Reminders' })(RemindersImg);
export const Mail = withIcon({ title: 'Mail' })(MailImg);
export const AppStore = withIcon({ title: 'AppStore' })(AppStoreImg);
export const Videos = withIcon({ title: 'Videos' })(VideosImg);
export const YouTube = withIcon({ title: 'YouTube' })(YouTubeImg);
export const Calculator = withIcon({ title: 'Calculator' })(CalculatorImg);
export const ITunes = withIcon({ title: 'ITunes' })(ITunesImg);
export const Stocks = withIcon({ title: 'Stocks' })(StocksImg);
export const VoiceMemos = withIcon({ title: 'VoiceMemos' })(VoiceMemosImg);
export const Weather = withIcon({ title: 'Weather' })(WeatherImg);
